import React, { useEffect } from "react";
import { useTranslation } from "@/hooks/useTranslation";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "next/navigation";
import { fetchAgreements } from "@/networking/agreements.api";
import Header from "../checkout/header";

export default function AgreementPreview({
  agreementId,
}: {
  agreementId: string;
}) {
  const { changeLanguage } = useTranslation();
  const searchParams = useSearchParams();
  const languageIso = searchParams?.get("languageIso") ?? "en";

  const { data: agreement, isLoading } = useQuery({
    queryKey: ["agreement", agreementId, languageIso],
    queryFn: async () => {
      await changeLanguage(languageIso);
      return fetchAgreements(agreementId, languageIso);
    },
    select: (data) => data.agreement,
  });

  useEffect(() => {
    if (languageIso) {
      changeLanguage(languageIso);
    }
  }, [languageIso, changeLanguage]);

  const handleLanguageChange = (language: string) => {
    changeLanguage(language);
  };

  return (
    <>
      <Header
        isLoading={isLoading}
        companyLogoUrl={agreement?.company_logo}
        handleLanguageChange={handleLanguageChange}
      />
      <div className="flex flex-col items-center justify-center bg-white">
        <h1 className="text-2xl font-bold pt-2">{agreement?.title}</h1>
        <div
          className="w-full overflow-y-auto"
          style={{ height: "calc(100vh - 150px)" }}
        >
          <iframe
            srcDoc={agreement?.description || ""}
            className="w-full h-full items-center border-none px-10 py-2"
            title="Agreement Content"
          />
        </div>
      </div>
    </>
  );
}
